// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__12ccU","overflowing":"ReadFullNote_overflowing__BdcJt"};